
export enum EnumSemRoteiroRequest {
  Estabelecimento = 'Estabelecimento',
  Cliente = 'Cliente',
  Promotor = 'Promotor',
}
